<div class="not-found-container">
  <div class="not-found-content">
    <span class="not-found-code">404</span>
    <h1 class="not-found-title">No encontrado</h1>
    <p class="not-found-message">La página que buscas no existe o fue movida.</p>
    <a routerLink="/" class="not-found-btn">Volver al inicio</a>
  </div>
</div>
